import moment from 'moment'
import get from 'lodash.get'
import { LOCALE } from '~/types'

export const round = value => {
  return Math.round(value * 10) / 10
}

export const toNumber = value => {
  return (+(value) || 0)
}

export const dateFormatter = (date: Date, locale: LOCALE, timezone?: number, timeShiftInMinutes?: number, isHhMm: boolean, isSyntheticDealer: boolean): string => {
  if (date) {
    let dateFormat = 'DD.MM.YY'
    if (locale === 'en') {
      dateFormat = 'MM/DD/YY'
    }
    if (isHhMm) {
      dateFormat += ' HH:mm'
    }
  	if (typeof timezone !== 'number') {
      let browserTimezoneOffset = new Date().getTimezoneOffset() * -1
      if ((date + '').includes('T00:00:00.000Z')) {
        browserTimezoneOffset = 0
      }
      timezone = browserTimezoneOffset / 60
    }
    if (isSyntheticDealer) {
      timezone = 0
    }
		let momentDate = moment(date).utcOffset(timezone).locale(locale)
		if (timeShiftInMinutes) {
			momentDate = momentDate.add(timeShiftInMinutes, 'm')
		}
		return momentDate.format(dateFormat)
  }
}

export const serverDateFormatter = (date: Date): string =>
  moment(date).format('yyyy-MM-DD HH:mm:ss')

export const pointLocationFormatter = (point: string): string =>
  get(point, ['description'], '')

export const addCellType = cell => {
  let type = 'normal'
  switch (cell.column.id) {
    case 'status':
      type = 'status'
      break
    case 'nps':
      type = 'nps'
      break
    case 'Why Via?':
      type = 'Why Via?'
      break
    case 'paid':
    case 'is_delivery_complete':
      type = 'true-false'
      break
    case 'datetime':
    case 'created_at':
    case 'statusDate':
    case 'deliveryStartedDate':
    case 'delivery_date':
    case 'delivery_complete':
    case 'expiration_date':
    case 'Address Change Date':
      type = 'date'  
      break
    case 'sum':
    case 'commission':
    case 'delivery_cost_dealer':
    case 'taxes_included':
    case 'total':
    case 'packagePrice':
    case 'discount_included':
      type = 'currency'
      cell.textAlign = 'right'
      break
    case 'orderWeightKg':
      type = 'weight'
      break
    case 'tracking_url':
      type = 'delivery-tracking'
      break
    case 'timezone':
      type = 'timezone'
  }

  return {
    ...cell,
    type,
  }
}

export const fullAdressFormatter = ({ city_pref, city, street }) =>
  `${city_pref || ''} ${city || ''}, ${street || ''}`

export const currencyFormatter = ({ currency, value }): string => {
  const locales = {
    'RUB': 'ru-RU',
    'USD': 'en-EN',
    'GBP': 'en-EN',
    'EUR': 'en-EN'
  }

  if (!currency) return value

  return new Intl.NumberFormat(locales[currency], { style: 'currency', currency }).format(value)
}

export const lengthByLocaleFormatter = ({ length, locale, t }) => {
  if (locale === 'en') {
    // to feet (ft.[in])
    // 1ft = 12in
    const inch = round(length / 25.4)
    // const lengthInInches = round(length / 25.4)
    // const lengthInFeet = round(lengthInInches / 12)
    // const ft = Math.trunc(lengthInFeet)
    // const inch = Math.round((lengthInFeet - ft) * 12)
    // return `${ft ? ft + 'ft' : ''} ${inch ? inch + 'in' : ''}`
    return `${inch ? Math.round(inch) + (t ? t('in') : 'in') : ''}`
  }

  return round(length) + (t ? t('mm') : 'мм')
}

export const weightByLocaleFormatter = ({ weight, locale, separate, weightGr, t }) => {
  if (!weightGr && (typeof weight === 'undefined' || isNaN(weight) || Number(weight) === 0)) {
    return `0${locale === 'en' ? 'lb' : 'кг'}`
  }

  if (locale === 'en') {
    // to pounds (lb.[oz])
    // 1lb = 16oz
    let plainWeight = weight * 2.20462262185
  	if (weightGr) {
  		plainWeight = (weightGr * 2.20462262185) / 1000
  	}
    let lb = Math.trunc(plainWeight)
    let oz = Math.round((plainWeight % 1) * 16)
    if (oz === 16) {
      lb += 1
      oz = 0
    }
  	if (separate) {
  		return { lb, oz }
  	} else {
  		return `${lb ? lb + (t ? t('lb') : 'lb') : ''} ${oz > 0 ? oz + (t ? t('oz') : 'oz') : ''}`
  	}
  }

  return round(weight) + (t ? t('kg') : 'кг')
}